import { render } from "./BlocoInstagram.vue?vue&type=template&id=1af27850"
import script from "./BlocoInstagram.vue?vue&type=script&lang=js"
export * from "./BlocoInstagram.vue?vue&type=script&lang=js"

import "./BlocoInstagram.vue?vue&type=style&index=0&id=1af27850&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__